var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_36211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.51105 3.03235C11.4178 2.97723 13.3582 2.99679 15.2596 3.05902C17.2883 3.12551 18.993 3.24286 20.3823 4.90598C21.5103 6.25654 21.5522 7.73048 21.607 9.40641C21.6703 11.3412 21.67 13.303 21.6088 15.2371C21.549 17.1175 21.4708 18.7486 20.0442 20.1443C18.684 21.475 17.092 21.5578 15.2952 21.6183C13.3494 21.6837 11.374 21.6816 9.42891 21.6201C7.4838 21.5586 5.91776 21.4828 4.52168 20.0554C3.18144 18.6857 3.10712 17.0791 3.04774 15.2705C2.98409 13.3251 2.98409 11.3522 3.04774 9.40605C3.09894 7.84463 3.12917 6.43434 4.09853 5.1229C5.4569 3.28447 7.37819 3.09387 9.51105 3.03235ZM10.0089 4.70365C8.51183 4.73885 6.75625 4.66702 5.65959 5.86609C4.65361 6.96595 4.75673 8.48293 4.7194 9.86868C4.67495 11.5155 4.6753 13.1622 4.7194 14.8086C4.75496 16.1297 4.6529 17.503 5.50171 18.6135C6.57632 20.0195 8.2686 19.9043 9.85776 19.947C11.5049 19.9914 13.1506 19.9911 14.7977 19.947C16.1195 19.9114 17.4921 20.0135 18.6026 19.1647C20.0097 18.089 19.8934 16.3989 19.9361 14.8086C19.9802 13.1615 19.9805 11.5158 19.9361 9.86868C19.8987 8.48293 20.0015 6.96595 18.9959 5.86609C17.8914 4.65849 16.2905 4.7705 14.7977 4.73032C13.2093 4.68729 11.6027 4.66631 10.0092 4.70365H10.0089Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.248 7.54807C16.0156 7.48229 18.3845 11.6467 16.3946 14.8602C14.5349 17.8639 10.1504 17.876 8.27139 14.8819C6.29037 11.7249 8.53951 7.61315 12.2477 7.54807H12.248ZM11.928 9.25529C9.74107 9.47789 8.54982 12.0144 9.64115 13.9036C10.8157 15.9369 13.8091 15.9519 14.9996 13.9268C16.326 11.6705 14.5089 8.9925 11.928 9.25493V9.25529Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0851 6.26722C18.4851 6.06275 18.9058 7.9115 17.7462 8.38622C16.1453 9.04194 15.5632 6.48911 17.0851 6.26722Z",
    fill: "#F7F7F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_36211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6546,
    height: 18.6667,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.7b736428cbb6c30a6250ed2d591897db.svg";
export { ForwardRef as ReactComponent };